import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";

const invalidateSessionAndRedirect = () => {
  window.close();
  AuthenticationFailureHandler.logout();
};

const invalidateSession = () => {};

export { invalidateSession, invalidateSessionAndRedirect };
